<template>
   <div class="primary-btn-style justify-content-end"  style="padding: 0px !important; height: 100%; width:45px !important; float: inline-end;display: inline-flex;align-items: center;justify-content: center !important;border-radius: 4px;margin-inline-end:10px;">
        <!-- <button class="btn btn-outline-secondary m-2" style="border: 1px solid #585858;margin:0px !important;width:100px;margin-inline-end:10px;">Download</button> -->
        <button class="btn btn-outline-secondary m-2" style="width: 45px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
                <title>{{$t('Generate Report')}}</title>
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    // props: ["componentname", "showTopButtonBar"],
  
    methods:{
       
    },

}
</script>